import { useLoaderData } from "react-router-dom";

import Loading from "@/components/layout/loading";
import Resolver from "@/components/resolver";
import useProcessedState from "../hooks/use-processed-state";
import ResolvedView from "./resolved-view";

export default function ProjectOverviewView() {
  const { transactions } = useLoaderData();

  const { skipRender } = useProcessedState({ navigateToRoot: false });
  if (skipRender) return <></>;

  return (
    <div className="mt-10">
      <Resolver resolve={transactions} fallback={<Loading />}>
        <ResolvedView />
      </Resolver>
    </div>
  );
}
